<template>
	<div id="clubClass_right2">
		<div class="cc-header">参与度排名</div>
		<div class="main-value">
			<dv-scroll-ranking-board :config="config" class="rankChart" />
		</div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgId = storage.getItem("orgId");
export default {
	data() {
		return {
			config: {}
		};
	},
	mounted() {
		this.initData();
		// 定时器刷新，30分钟
		let _this = this;
		this.interval = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 30);
	},
	methods: {
		initData() {
			let _this = this;
			this.$http.get("/dataView/clubClass/getGradePartRate?orgId=" + orgId).then(res => {
				if (res.data.code === 200) {
					var result = [];
					for (var i = 0; i < res.data.result.length; i++) {
						var obj = res.data.result[i];
						var partRate = parseInt(obj.partRate * 100);
						if (i == 0) {
							result.push({ name: "<div style='color:#ffb855;'>0" + (i + 1) + "、" + obj.gradeName + "</div>", value: partRate });
						} else if (i == 1) {
							result.push({ name: "<div style='color:#38fa61;'>0" + (i + 1) + "、" + obj.gradeName + "</div>", value: partRate });
						} else if (i == 2) {
							result.push({ name: "<div style='color:#55fff2;'>0" + (i + 1) + "、" + obj.gradeName + "</div>", value: partRate });
						} else {
							if (i < 9) {
								result.push({ name: "<div>0" + (i + 1) + "、" + obj.gradeName + "</div>", value: partRate });
							} else {
								result.push({ name: "<div>" + (i + 1) + "、" + obj.gradeName + "</div>", value: partRate });
							}
						}
					}
					_this.config = {
						data: result,
						rowNum: 9, //表格行数
						waitTime: 2000,
						unit: "%" //数值单位
					}
				}
			});
		}
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
	destroyed() {
		window.onresize = null;
	}
};
</script>

<style lang="scss">
#clubClass_right2 {
	height: 100%;

	.cc-header {
		width: 100%;
		text-align: center;
		background: url("../../assets/img/ac_titbgsmall.png") center no-repeat;
		background-size: 100%;
		color: #0ef3ff;
		font-size: 0.22rem;
		font-weight: bold;
		height: 0.8rem;
		line-height: 0.6rem;
	}

	.main-value {
		height: 80%;
		padding-left: 1%;
	}

	.rankChart {
		width: 86%;
		margin-left: 7%;
		margin-top: -10px;

		.row-item {
			height: 4.5vh !important;
		}

		.rank {
			width: 50px;
			font-size: 0.18rem;
			color: #974cff;
			display: none;
		}

		.ranking-info {
			font-size: 0.19rem;
			margin-bottom: 0.05rem;
		}

		.info-name span {
			height: 0.5rem;
			width: 0.4rem;
			display: inline-block;
			background-size: 100% 100%;
			background-repeat: no-repeat;
			text-align: center;
			margin-right: 0.2rem;
			font-size: 0.12rem;
			line-height: 0.3rem;
		}

		.ranking-column {
			border-bottom: 0;
			margin-top: 0;
			background-color: rgba(255, 255, 255, 0.5);
			border-radius: 5px;
		}

		.inside-column {
			height: 0.12rem;
			margin-bottom: 0;
			border-radius: 5px;
			background-color: #974cff;
			background-image: -webkit-gradient(linear, left top, right top, from(#974cff), to(#5555ff));
			background-image: linear-gradient(to right, #974cff, #5555ff);
		}
	}
}</style>